import { LOCALES } from './constants.mjs';
import { config } from './config';

export { LOCALES };
export default config;
